module.exports = __webpack_public_path__ + "static/media/NatalieChaney.77013729.jpg";